import type { FilterField } from '@/components/common/AdvancedFilter';
import type { OrganizationItem } from '@/features/organization/types/organization.types';
import { toFilterOptions } from '@/utils/filters';
import { USER_STATUS } from '../constants/user.constants';
import type { UserType } from '../types/userType.types';

interface GetUserListFilterFieldsArgs {
  userTypeIds: readonly number[];
  showTypeFilter: boolean;
  userTypes: UserType[] | undefined;
  companies: OrganizationItem[] | undefined;
  departments: OrganizationItem[] | undefined;
  designations: OrganizationItem[] | undefined;
}

export function getUserListFilterFields({
  userTypeIds,
  showTypeFilter,
  userTypes,
  companies,
  departments,
  designations,
}: GetUserListFilterFieldsArgs): FilterField[] {
  const fields: FilterField[] = [];

  if (showTypeFilter) {
    fields.push({
      key: 'userTypeId',
      label: 'User Type',
      type: 'select',
      placeholder: 'All Types',
      options: userTypeIds.map((id) => ({
        label: userTypes?.find((t) => t.id === id)?.name ?? `Type ${id}`,
        value: String(id),
      })),
    });
  }

  fields.push(
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      options: USER_STATUS.map((status) => ({ label: status, value: status })),
    },
    {
      key: 'companyId',
      label: 'Company',
      type: 'select',
      placeholder: 'All Companies',
      options: toFilterOptions(companies),
    },
    {
      key: 'departmentId',
      label: 'Department',
      type: 'select',
      placeholder: 'All Departments',
      options: toFilterOptions(departments),
    },
    {
      key: 'designationId',
      label: 'Designation',
      type: 'select',
      placeholder: 'All Designations',
      options: toFilterOptions(designations),
    },
  );

  return fields;
}
